<template lang="pug">
  v-col(cols="12")
    v-alert.grey.lighten-4(
      v-if="gptHasAnswer"
      prominent
      :color="alertColor" border="top"
      colored-border
    )
      v-avatar(size="48" :color="`${alertColor} lighten-4`").mr-6
        .justify-center(:class="`${alertColor}--text`"): strong {{gptValue}}%
      strong Уверенность нейросети в ответе
    validation-observer(ref="obs")
      validation-provider(name="Отметка" vid="mark" v-slot="{ errors, valid }")
        v-textarea(
          v-model="comment"
          label="Оставить комментарии к заданию"
          :error-messages="errors"
          :disabled="Boolean(markId)"
          rounded filled
        )
      validation-provider(name="Отметка" vid="mark" v-slot="{ errors, valid }")
        v-text-field(
          v-model="mark"
          class="d-inline-flex"
          label="Отметка"
          type="number"
          :error-messages="errors"
          :disabled="Boolean(markId)"
          rounded filled
        )
      v-row.pa-4
        v-spacer
        h4.red--text Внимание: после выбора оценки, дальнейшее её измененение будет недоступно!
      v-row.pa-4
        sdo-back-button
        v-spacer
        v-btn(
          color="success"
          :loading="loadings.sendBtn"
          :class="getButtonClasses(TASK_STATUSES.success)"
          rounded depressed
          @click="handleConfirmDialog(TASK_STATUSES.success)"
        )
          v-icon(left) mdi-check
          | Зачет
        v-btn.ml-2(
          color="error"
          :loading="loadings.sendBtn"
          :class="getButtonClasses(TASK_STATUSES.fail)"
          rounded depressed
          @click="handleConfirmDialog(TASK_STATUSES.fail)"
        )
          v-icon(left) mdi-close
          | Незачет
        //- v-btn.ml-2(
        //-   color="warning"
        //-   :loading="loadings.sendBtn"
        //-   :class="getButtonClasses(TASK_STATUSES.retake)"
        //-   rounded depressed
        //-   @click="handleConfirmDialog(TASK_STATUSES.retake)"
        //- )
        //-   v-icon(left) mdi-undo-variant
        //-   | На пересдачу

        //- v-btn.ml-2(
        //-   color="success"
        //-   :loading="loadings.sendBtn"
        //-   :class="getButtonClasses(TASK_STATUSES.done)"
        //-   rounded depressed
        //-   @click="handleConfirmDialog(TASK_STATUSES.done) "
        //- )
        //-   v-icon(left) mdi-check
        //-   | Задание выполнено
    confirm-dialog(
      v-model="confirmDialog.active"
      @confirm="confirmDialog.method"
    )
      template(#header)
        span Подтвердите оценку работы.
      template(#body)
        span Будет поставлен {{ TASK_STATUS_NAMES[confirmDialog.type] }}
        strong.ml-2.error--text Оценку нельзя будет изменить
        v-alert.mt-4(
          v-if="knowledgeBaseId"
          icon="mdi-database"
          color="grey lighten-4"
        )
          v-row.ma-0.align-center
            span Пополнить базу знаний
            v-spacer
            v-switch.mt-0(
              v-model="confirmDialog.sendToDataKnowledge"
              hide-details
            )
      template(#actions)
        v-btn(
          text
          color="error"
          @click="confirmDialog.active = false"
        ) Отмена
        v-spacer
        v-btn(
          text
          color="success"
          @click="confirmDialog.method"
        ) Подтвердить

</template>

<script>
import TaskService from '@/services/API/TaskService';
import { TASK_STATUSES, TASK_STATUS_NAMES } from '@/utils/constants';

export default {
  name: 'TaskViewAnswersMark',
  props: {
    groupId: {
      type: Number,
      default: 0,
    },
    taskId: {
      type: Number,
      default: 0,
    },
    userId: {
      type: Number,
      default: 0,
    },
    journalId: {
      type: Number,
      default: 0,
    },
    knowledgeBaseId: {
      type: Number,
      default: null,
    },
    answerForGpt: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    confirmDialog: {
      active: false,
      method: false,
      sendToDataKnowledge: false,
    },
    loadings: {},
    comment: '',
    mark: '',
    markId: null,
    status: null,
    TASK_STATUSES,
    TASK_STATUS_NAMES,
  }),
  computed: {
    actionButtonStatus() {
      return Boolean((!this.mark && !this.markId) || this.markId);
    },
    gptHasAnswer() {
      if (this.answerForGpt) {
        const [gptRequest] = this.answerForGpt?.gpt_requests;
        return gptRequest && gptRequest?.response?.answer !== 'no-answer';
      }
      return false;
    },
    gptValue() {
      return this.answerForGpt?.gpt_requests[0]?.value || 0;
    },
    alertColor() {
      const colors = ['error', 'warning', 'success'];
      return colors.filter((_, idx) => {
        const { length } = colors;
        const max = (100 / length) * (idx + 1);
        return this.gptValue < max;
      }).shift();
    },
  },
  mounted() {
    this.getMark();
    if (this.gptHasAnswer) this.comment = this.answerForGpt?.gpt_requests[0]?.response?.answer;
  },
  methods: {
    handleConfirmDialog(callback) {
      this.confirmDialog.active = true;
      this.confirmDialog.type = callback;
      this.confirmDialog.method = () => {
        if (this.confirmDialog.sendToDataKnowledge) this.sendToDataKnowledge();
        this.sendMark(callback);
      };
    },
    sendToDataKnowledge() {
      const params = {
        is_writer: true,
        type: 1,
        knowledge_base_id: this.knowledgeBaseId,
        question: { text: this.answerForGpt.string_answer },
        answer: { text: this.comment },
      };
      this.$api.gptPulse.createQuestion(params);
    },
    /**
     * Получить css-классы для кнопки оценки
     * @param {number} buttonAction - Числовой код действия кнопки
     * @returns {string}
     */
    getButtonClasses(buttonAction) {
      if ((!this.mark && !this.markId) || this.markId) {
        if (this.status === buttonAction) {
          return 'disabled-button--selected';
        }
        return 'disabled-button';
      }
      return '';
    },
    getMark() {
      this.$rHandler(
        TaskService.getMark(this.groupId, this.taskId, this.userId),
        (r) => {
          if (r.data.data) {
            this.markId = r.data.data.id;
            this.mark = r.data.data.mark;
            this.comment = r.data.data.comment;
            this.status = r.data.data.status;
          }
        },
      );
    },
    sendMark(status = 4) {
      this.wasMarkSent = true;
      this.$set(this.loadings, 'sendBtn', true);
      const data = {
        task_id: this.taskId,
        user_id: this.userId,
        group_id: this.groupId,
        mark: this.mark,
        comment: this.comment,
        journal_answer_id: this.journalId,
        status,
      };

      let request;
      if (this.markId !== null) {
        request = TaskService.updateMark(this.markId, data);
      } else {
        request = TaskService.addMark(data);
      }

      this.$rHandler(
        request,
        () => {
          this.$toasted.success('Оценка добавлена', { duration: 3000 });
          this.$router.go(-1);
          this.$delete(this.loadings, 'sendBtn');
        },
        () => {
          this.$delete(this.loadings, 'sendBtn');
        },
        this.$refs.obs,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .disabled-button{
    background-color: rgba(0, 0, 0, 0.26) !important;
    pointer-events: none;
  }
  .disabled-button--selected{
    opacity: 0.6;
    pointer-events: none;
  }
</style>
